import HttpError from 'core/exceptions/httpError';

export default class HttpUnprocessableEntity extends HttpError {}
